// extracted by mini-css-extract-plugin
export var blink = "_78-2";
export var cursor = "_78-1";
export var reactMarkdown = "_78-3";
export var streamingText = "_78-0";